import users from "../services/account.users";
import notification from "../services/notification";
import _ from "lodash";

export default {
    namespaced: true,
    state: {
        loading: false,
        errors: null,
        users: [],
        cmsModuleOptions: [],
        enabledCmsPermissions: [],
        pagination: {
            currentPage: 1,
            prevPage: 0,
            nextPage: 0,
            maxPage: 0,
            totalPerPage: 1,
            currentFirstItem: 1,
            currentLastItem: 1,
            initialPageCount: 0,
            perPage: 10
        },
        maxPage: 1,
        nextPage: 0,
        prevPage: 0,
        currentPage: 1,
        initializing: false,
        creating: true,
        activeUserUuid: null,
        form: {},
        userBrandBranches: {}
    },
    mutations: {
        loading(state) {
            state.loading = true;
        },
        errors(state, errors) {
            state.errors = errors;
            state.loading = false;
        },
        users(state, users) {
            state.users = users;
        },
        cmsModuleOptions(state, cmsModuleOptions) {
            const estoreModule = cmsModuleOptions.find(module => module.name === "Estore");
            const mechanicsModule = cmsModuleOptions.find(module => module.name === "Mechanics");
            const engagementModule = cmsModuleOptions.find(module => module.name === "Engagement");

            if (estoreModule) {
                const deliveryIndex = estoreModule.child_modules.indexOf(estoreModule.child_modules.find(sub => sub.code === "delivery:topup-estore"));

                estoreModule.child_modules.splice(deliveryIndex, 1);
            }
            if (mechanicsModule) {
                const membershipIndex = mechanicsModule.child_modules.indexOf(mechanicsModule.child_modules.find(sub => sub.code === "membership"));
                mechanicsModule.child_modules.splice(membershipIndex, 1);
            }
            if (engagementModule) {
                const facebookAdsIndex = engagementModule.child_modules.indexOf(engagementModule.child_modules.find(sub => sub.code === "facebook-ads"));
                engagementModule.child_modules.splice(facebookAdsIndex, 1);
            }

            state.cmsModuleOptions = cmsModuleOptions;
        },
        enabledCmsPermissions(state, enabledCmsPermissions) {
            state.enabledCmsPermissions = enabledCmsPermissions;
        },
        pagination(state, pagination) {
            state.maxPage = pagination.max_page;
            state.prevPage = pagination.prev_page;
            state.nextPage = pagination.next_page;
            state.currentPage = state.prevPage + 1;
            state.pagination.totalPerPage = pagination.list.length;
            state.pagination.maxPage =
                state.pagination.totalPerPage > 0 ? pagination.max_page : 0;
            state.pagination.prevPage = pagination.prev_page;
            state.pagination.nextPage = pagination.next_page;
            state.pagination.currentPage = state.pagination.prevPage + 1;
            state.pagination.currentFirstItem =
                state.pagination.totalPerPage > 0
                    ? state.pagination.initialPageCount *
                            state.pagination.prevPage +
                        1
                    : 0;
            state.pagination.currentLastItem =
                state.pagination.currentFirstItem > 0
                    ? state.pagination.currentFirstItem +
                        state.pagination.totalPerPage -
                        1
                    : 0;
        },
        initializedForm(state, form) {
            state.form = form;
        },
        updateList(state, value) {
            state.users.unshift(value);
        },
        initializing(state) {
            state.initializing = true;
        },
        creating(state, value) {
            state.creating = value;
        },
        activeUserUuid(state, value) {
            state.activeUserUuid = value;
        },
        setUserBrandBranches(state, brandBranches) {
            state.userBrandBranches = brandBranches;
        },
        setInitialPageCount(state, list) {
            state.pagination.initialPageCount = list.length;
        },
    },
    getters: {
        userBrandBranches (state) {
            return state.userBrandBranches;
        }
    },
    actions: {
        async getUsers({ commit, state }, param) {
            commit("loading");
            try {
                let response = await users.getUsers(param);
                
                if (param.page === 1) {
                    await commit("setInitialPageCount", response.list);
                }
                
                commit("users", response.list);
                commit("pagination", response);
                state.loading = false;
            } catch (errors) {
                commit("errors", errors);
            }
        },
        async createUser({ commit, state }, param) {
            commit("errors", null);
            commit("loading");
            notification.info("Please wait, this will take a moment.");
            try {
                let response = await users.createUser(param);
                commit("updateList", response.user);
                notification.success(response.message);
                state.loading = false;
                return response;
            } catch (errors) {
                commit("errors", errors);
                notification.warning("Oops, cannot create user.");
            }
        },
        async updateUser({ commit, state }, param) {
            commit("errors", null);
            commit("loading");
            try {
                let response = await users.updateUser(
                    param,
                    state.activeUserUuid
                );
                let index = _.findIndex(state.users, function(row) {
                    return row.uuid === state.activeUserUuid;
                });
                _.forEach(response.user, function(value, key) {
                    state.users[index][key] = value;
                });
                state.loading = false;
                notification.success(response.message);
                return response;
            } catch (errors) {
                commit("errors", errors);
                notification.warning("Oops, cannot update user.");
            }
        },
        async getCmsModuleOptions({ commit }) {
            try {
                let response = await users.getCmsModuleOptions();
                commit("cmsModuleOptions", response);
            } catch (errors) {
                commit("errors", errors);
            }
        },
        async getCmsModuleAccess({ commit, state }, uuid) {
            commit("errors", null);
            commit("initializing");
            try {
                let response = await users.getCmsModuleAccess(uuid);
                state.initializing = false;
                return response;
            } catch (errors) {
                commit("errors", errors);
            }
        },
        async resetForm({ commit }, form) {
            try {
                commit("initializedForm", form);
            } catch (errors) {
                commit("errors", errors);
            }
        },
        async getUserDetails({ commit }, uuid) {
            try {
                commit("errors", null);
                const response = await users.getUserDetails(uuid);
                commit("setUserBrandBranches", response.metas);
            } catch (errors) {
                commit("errors", errors);
            }
        },
        async deleteUser({ commit, state }, param) {
            try {
                let response = await users.deleteUser(param);
                notification.success(response.message);
                return response;
            } catch (errors) {
                commit("errors", errors);
                notification.warning("Oops, cannot delete user.");
            }
        },
        async activateOrDeactivateUser({ commit, state }, param) {
            try {
                let response = await users.activateOrDeactivateUser(param);
                notification.success(response.message);
                return response;
            } catch (errors) {
                commit("errors", errors);
                if(param.mode === "activate") {
                    notification.warning("Oops, cannot activate user.");
                } else {
                    notification.warning("Oops, cannot deactivate user.");
                }
            }
        }
    }
};
